function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "insert");

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  y: 577.66157,
  width: 1039.82764,
  height: 2,
  fill: "#3f3d56"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 669.68503,
  y: 216.92404,
  width: 59.47284,
  height: 86.67224,
  transform: "translate(1318.75671 381.13756) rotate(-180)",
  fill: "#2f2e41"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M717.6643,256.9052s-2.23749,42.79077,17.54822,44.54548c13.84336,1.22771-26.99726,39.146-26.99726,39.146l-35.09644-48.59507s26.308,2.69433,9.449-26.99726Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#ffb8b8"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M673.11681,292.006l11.09,15.36,24.00995,33.23s20.05-18.62,27.29-30.18c2.72-4.35,3.64-7.7,1-8.69a.06016.06016,0,0,0-.04-.01,4.28622,4.28622,0,0,0-1.18-.26.41786.41786,0,0,0-.07-.01,12.56047,12.56047,0,0,1-3.37-.76c-16.16-6.04-14.18-43.78-14.18-43.78l-35.1,8.1c11.25,19.81,3.28,25.21-3.27,26.6a21.85055,21.85055,0,0,1-4.37.46C673.81682,292.076,673.11681,292.006,673.11681,292.006Z",
  transform: "translate(-80.08618 -139.38276)",
  opacity: 0.1
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M662.80027,221.761c6.42577,19.02511,16.27886,36.35985,36.35985,36.35985S734.38851,241.81,735.52,221.761c1.44577-25.61874-15.81562-36.466-36.35984-36.35985C674.89045,185.52647,655.17441,199.18277,662.80027,221.761Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#2f2e41"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M748.71116,530.92742l-9.449,66.14329s8.09918,40.4959,4.04959,68.843l-4.04959,29.697H720.364l-5.39945-31.04685s-5.39946-32.39672-5.39946-47.24521c0,0-14.84849-67.49316-5.39945-80.99179Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#ffb8b8"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M633.97279,526.87783l9.449,70.19288s-8.09918,40.4959-4.04959,68.843l4.04959,29.697h18.89808l5.39946-31.04685s5.39945-32.39672,5.39945-47.24521c0,0,14.84849-71.54275,5.39945-85.04138Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#ffb8b8"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M652.87087,691.56113s-10.7989-4.04959-12.14877,1.34987-4.04959,33.74657-4.04959,33.74657-8.09917,12.14877-13.49863,13.49864-17.54822,18.89808-2.69972,20.24794,29.697-4.04959,29.697-6.74931,5.39945-4.04959,8.09917-4.04959,12.14877-4.04959,10.79891-8.09918-5.39945-51.2948-5.39945-51.2948Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#2f2e41"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M729.81307,691.56113s10.79891-4.04959,12.14877,1.34987,4.04959,33.74657,4.04959,33.74657,8.09918,12.14877,13.49863,13.49864,17.54822,18.89808,2.69973,20.24794-29.697-4.04959-29.697-6.74931-5.39945-4.04959-8.09918-4.04959-12.14877-4.04959-10.79891-8.09918,5.39946-51.2948,5.39946-51.2948Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#2f2e41"
});

var _ref12 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 617.33017,
  cy: 105.37367,
  r: 27.98955,
  fill: "#ffb8b8"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M592.12682,398.636s56.69,24.3,62.09-1.35a370.69889,370.69889,0,0,0,6.75-48.59.035.035,0,0,1,.02-.01c.79-.48,28.72-17.62,23.22-41.32a35.72334,35.72334,0,0,0-7.04-14.01s-.83-.54-2.24-1.29a44.78407,44.78407,0,0,0-5.11-2.33c-9.53-3.63-25.38-5.68-29.09,18.46-5.4,35.1-5.4,72.9-5.4,72.9s-16.2,9.45-37.8,0-43.2-4.05-44.55,8.1C551.62682,401.336,592.12682,398.636,592.12682,398.636Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#ffb8b8"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M735.21679,301.446l.29,8.97,3.22,101.12.54,16.80005,47.24,52.65s9.45,28.34,29.7,32.39-13.5-39.14-13.5-39.14l-45.9-67.5-.07-2.27a256.5938,256.5938,0,0,1,4.7-56.39,67.62267,67.62267,0,0,0,.77-20.98c-1.88-15.06-14.27-21.59-21.59-24.16a36.94742,36.94742,0,0,0-4.11-1.21.06016.06016,0,0,0-.04-.01c-.61-.15-1.02-.23-1.18-.26A.41786.41786,0,0,0,735.21679,301.446Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#ffb8b8"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M659.61681,398.636v5.4c19.68,24.05005,63.24,12.69,79.11,7.5,3.73-1.22,5.93-2.1,5.93-2.1a13.964,13.964,0,0,1-1.35-5.4V391.896c0-4.05-1.34-1.35-2.69-2.7s4.04-9.45,4.04-9.45c13.5-8.1,5.4-31.05,5.4-31.05l-9.44-20.25v-25.51a36.94742,36.94742,0,0,0-4.11-1.21.06016.06016,0,0,0-.04-.01,4.28622,4.28622,0,0,0-1.18-.26.41786.41786,0,0,0-.07-.01,12.56047,12.56047,0,0,1-3.37-.76c-2.53,5.22-8.03,12.09-19.58,12.91-13.83.99-26.94-13.92-32.97-21.99a21.85055,21.85055,0,0,1-4.37.46,44.78407,44.78407,0,0,0-5.11-2.33l6,25.21c5.31,13.27-14.16,33.05-14.83,33.74a.035.035,0,0,0-.02.01v14.85l1.35,16.2,1.35,4.05-2.7,4.05,1.35,4.05-1.35,2.7C659.61681,397.28593,659.61681,395.946,659.61681,398.636Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#d0cde1"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M741.96184,408.08987l4.04959-1.34986s48.59507,121.48768,16.19836,126.88713-56.69426,14.8485-62.09371,5.39946-2.69972-43.19562-2.69972-43.19562l-5.39946-1.34987s9.44905,49.94494-9.449,45.89535-71.54275-10.79891-71.54275-16.19836,48.59508-122.01381,48.59508-122.01381S679.86813,414.83919,741.96184,408.08987Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#2f2e41"
});

var _ref17 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 619.07393,
  cy: 39.32048,
  r: 14.35257,
  fill: "#2f2e41"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M716.3832,171.04854a14.35318,14.35318,0,0,0-12.91731-14.2801c.47217-.04689.9507-.07247,1.43525-.07247a14.35257,14.35257,0,1,1,0,28.70514c-.48455,0-.96308-.02558-1.43525-.07247A14.35322,14.35322,0,0,0,716.3832,171.04854Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#2f2e41"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M710.71757,208.71556s.2997-1.66833,12.02072,2.72706,18.747,36.83138,12.88645,55.878c-2.36176,7.67573-.44051,13.21,2.69525,17.08212,11.76727,14.53076,7.135,36.35555-10.005,43.82777q-.72568.31637-1.481.62548l-7.32564,4.39538s9.33861-12.28765,4.66522-28.00582a80.58881,80.58881,0,0,1-1.45426-41.256c.53616-2.30181,1.1452-4.67455,1.837-7.09594,5.86051-20.51179,3.01021-18.143-17.50158-38.65477,0,0-11.721,8.79076-21.97691,13.18614s-19.04666,8.79077-11.721,23.442S698.264,282.70451,686.543,301.75117s-13.18615,11.721-11.721,19.04666h0l1.46513,7.32564-8.79077-8.79077,5.86052,11.721s-19.04666,0-24.90718-14.65128l-2.93025,2.93026s-11.721-20.51179,10.25589-39.55845c0,0,7.32564-4.39538-2.93025-19.04666s-2.37925-46.15152,10.8069-52.012S710.71757,208.71556,710.71757,208.71556Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#2f2e41"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M566.88882,273.14277v65.68a2.29613,2.29613,0,0,1-2.29,2.29H562.9689v342.15a35.702,35.702,0,0,1-35.70007,35.7H313.47891a35.69346,35.69346,0,0,1-35.69006-35.7v-330.15H276.6088a1.6176,1.6176,0,0,1-1.62-1.61005V314.12281a1.61971,1.61971,0,0,1,1.62-1.62006h1.18005V298.4228h-1.19006a1.69647,1.69647,0,0,1-1.69-1.7v-36.87a1.69432,1.69432,0,0,1,1.69-1.69h1.19006v-19.22h-1.21008a1.498,1.498,0,0,1-1.5-1.5v-20.12a1.50661,1.50661,0,0,1,1.5-1.51h1.21008v-40.74a35.69136,35.69136,0,0,1,35.69006-35.69H527.26883a35.69991,35.69991,0,0,1,35.70007,35.69v95.78h1.62989A2.29608,2.29608,0,0,1,566.88882,273.14277Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#3f3d56"
});

var _ref21 =
/*#__PURE__*/
React.createElement("rect", {
  x: 313.30627,
  y: 18.3068,
  width: 39.82343,
  height: 8.08642,
  rx: 2.54189,
  fill: "#e6e8ec"
});

var _ref22 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 363.7377,
  cy: 22.35,
  r: 4.58665,
  fill: "#e6e8ec"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M545.87384,182.13258v504.09a22.65045,22.65045,0,0,1-22.65,22.64h-204.65a22.6106,22.6106,0,0,1-22.65-22.64v-504.09a22.649,22.649,0,0,1,22.65-22.65h30.63v3.93a18.65015,18.65015,0,0,0,18.65,18.65h104.08a18.6501,18.6501,0,0,0,18.65-18.65v-3.93h32.64A22.64266,22.64266,0,0,1,545.87384,182.13258Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#00b0ff"
});

var _ref24 =
/*#__PURE__*/
React.createElement("rect", {
  x: 225.82764,
  y: 185.35056,
  width: 232,
  height: 113,
  opacity: 0.2
});

var _ref25 =
/*#__PURE__*/
React.createElement("rect", {
  x: 757.49011,
  y: 281.15986,
  width: 232,
  height: 113,
  fill: "#f2f2f2"
});

var _ref26 =
/*#__PURE__*/
React.createElement("rect", {
  x: 225.82764,
  y: 356.62983,
  width: 232,
  height: 113,
  fill: "#3f3d56"
});

var _ref27 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 433.82764,
  cy: 81.62983,
  r: 20,
  fill: "#fff"
});

var _ref28 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "442.828 80.987 434.47 80.987 434.47 72.63 433.185 72.63 433.185 80.987 424.828 80.987 424.828 82.273 433.185 82.273 433.185 90.63 434.47 90.63 434.47 82.273 442.828 82.273 442.828 80.987",
  fill: "#3f3d56"
});

var _ref29 =
/*#__PURE__*/
React.createElement("rect", {
  x: 731.49011,
  y: 266.15986,
  width: 232,
  height: 113,
  fill: "#3f3d56"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M915.14277,481.41281c6.07316,22.45006,26.87512,36.354,26.87512,36.354s10.95541-22.49485,4.88225-44.94491S920.025,436.4679,920.025,436.4679,909.06961,458.96275,915.14277,481.41281Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#fff"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M924.06686,476.58805c16.66484,16.22256,18.70033,41.1604,18.70033,41.1604s-24.98356-1.36411-41.64841-17.58667-18.70034-41.1604-18.70034-41.1604S907.402,460.3655,924.06686,476.58805Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#00b0ff"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M399.32245,573.60351c6.07316,22.45006,26.87512,36.35395,26.87512,36.35395s10.95541-22.49485,4.88225-44.94491-26.87512-36.354-26.87512-36.354S393.24929,551.15345,399.32245,573.60351Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#fff"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M408.24654,568.77875c16.66484,16.22256,18.70033,41.1604,18.70033,41.1604s-24.98356-1.36411-41.64841-17.58667-18.70034-41.1604-18.70034-41.1604S391.58169,552.5562,408.24654,568.77875Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#00b0ff"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M454.57129,573.60351c-6.07316,22.45006-26.87511,36.35395-26.87511,36.35395s-10.95541-22.49485-4.88225-44.94491,26.87511-36.354,26.87511-36.354S460.64446,551.15345,454.57129,573.60351Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#fff"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M445.64721,568.77875c-16.66485,16.22256-18.70034,41.1604-18.70034,41.1604s24.98357-1.36411,41.64841-17.58667,18.70034-41.1604,18.70034-41.1604S462.31206,552.5562,445.64721,568.77875Z",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#00b0ff"
});

var _ref36 =
/*#__PURE__*/
React.createElement("rect", {
  x: 275.82764,
  y: 167.35056,
  width: 232,
  height: 113,
  fill: "#3f3d56"
});

var _ref37 =
/*#__PURE__*/
React.createElement("rect", {
  x: 390.9751,
  y: 206.09467,
  width: 2,
  height: 74.41113,
  fill: "#fff"
});

var _ref38 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 391.97533,
  cy: 207.0943,
  r: 10.52282,
  fill: "#00b0ff"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M472.06151,391.33833s-1.50326-32.33193-32.32009-28.57378",
  transform: "translate(-80.08618 -139.38276)",
  fill: "#fff"
});

var SvgProjectCover1 = function SvgProjectCover1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "a843d524-97c3-496f-96e4-6ebb49b633ff",
    "data-name": "Layer 1",
    width: 1039.82764,
    height: 621.23448,
    viewBox: "0 0 1039.82764 621.23448",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProjectCover1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/projectCover1.942e022b.svg";
export { ForwardRef as ReactComponent };